export const QUESTIONNAIRE_POSITION_KEY = 'sf_lq_position'
